/**
 * 文件路径: D:\XXY\MeiShan_Project\frontend\packages\merchant-admin\src\main.ts
 * 应用主入口文件
 */

import { createApp, markRaw } from 'vue'
import type { Component, App as VueApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import { TokenManager } from '@shared/api'
import { installPermissionDirectives } from '@shared/directives/permission'

// 样式导入
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@shared/styles/theme.css'
import '@shared/styles/form-standards.css'
import '@shared/styles/confirm-dialogs.css'
import './styles/app-theme.css'

// 设置默认暗色主题
document.documentElement.setAttribute('data-theme', 'dark')
document.documentElement.classList.add('dark')

// 创建应用实例
const app = createApp(App)

// 为本应用设置本地存储前缀，确保与其他后台并存登录互不干扰
if (import.meta?.env?.DEV) console.info('[App][merchant-admin] bootstrap')
TokenManager.setKeyPrefix('merchant_')

// 基路径自动跳转逻辑（开发阶段关闭强制 replace，交给路由守卫处理）
try {
  const base = '/merchant-admin/'
  const path = window.location.pathname
  if (import.meta?.env?.DEV) console.info('[App][merchant-admin] path', { path })
  if (path === base && !TokenManager.hasValidAuth()) {
    // 使用路由导航而不是 location.replace，避免必须手动输入 /login
    router.replace('/login')
  }
} catch {}

// 配置 Pinia 状态管理
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 注册 Element Plus 图标（使用 markRaw 避免响应式包装，遵循 Vue 3 最佳实践）
for (const [key, component] of Object.entries(ElementPlusIconsVue as Record<string, Component>)) {
  app.component(key, markRaw(component))
}

// 注册插件
app.use(pinia)
app.use(ElementPlus)
app.use(router)
installPermissionDirectives(app as VueApp<Element>)

// 挂载应用
app.mount('#app')


